import React, { useEffect, useState } from 'react'

import {
  AutoCompleteInput,
  Button,
  CheckBox,
  Grid,
  Input,
  Picker,
  TextArea
} from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import { useDebounce } from 'hooks'
import { ContractServices } from 'services/NGT/Contract'
import { SPACING } from 'utils'

export interface IHeaderNovoCRE {
  control: any
  errors: any
  handleGetCreInicial: (onSearchButton: boolean) => void
  setNmFornecedor: (value: string) => void
  checklist?: boolean
  isAnaliseCre: boolean
  nmFornecedor?: string
  StartAnalyze: (value: boolean) => void
  cdContratoSelected?: string
  novaAnalise?: boolean
  flLiberado?: boolean
  flBloqueado?: boolean
  idCre: number
  nmCentroPlanta: string;
}

const HeaderNovoCRE: React.FC<IHeaderNovoCRE> = ({
  checklist = false,
  control,
  errors,
  handleGetCreInicial,
  isAnaliseCre,
  setNmFornecedor,
  cdContratoSelected,
  nmFornecedor,
  StartAnalyze,
  novaAnalise,
  flLiberado,
  flBloqueado,
  idCre,
  nmCentroPlanta
}) => {
  const [autoCompleteContract, setAutoCompleteContract] = useState([])
  const [isLoadingContract, setIsLoadingContract] = useState(false)
  const [renderFlagChecklist, setRenderFlagChecklist] = useState<boolean>(false)
  const [renderLiberado, setRenderLiberado] = useState<boolean>(false)
  const [renderBloqueado, setRenderBloqueado] = useState<boolean>(false)

  const searchContract = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsLoadingContract(true)
    ContractServices()
      .GetContractByCodigo(event.target.value)
      .then(({ data }) => setAutoCompleteContract(data.entity))
      .finally(() => setIsLoadingContract(false))
  }

  useEffect(() => {
    if (
      !autoCompleteContract.filter(
        (n) => n?.cdContrato === cdContratoSelected
      )[0]?.nmFornecedor
    ) {
      setNmFornecedor(nmFornecedor)
    } else {
      setNmFornecedor(
        autoCompleteContract.filter(
          (n) => n?.cdContrato === cdContratoSelected
        )[0]?.nmFornecedor
      )
    }
  }, [autoCompleteContract])

  useEffect(() => {
    if (checklist === true || checklist === false) setRenderFlagChecklist(true)
  }, [checklist])

  useEffect(() => {
    if (flLiberado === true || flLiberado === false) setRenderLiberado(true)
  }, [flLiberado])

  useEffect(() => {
    if (flBloqueado === true || flBloqueado === false) setRenderBloqueado(true)
  }, [flBloqueado])

  return (
    <>
      <Grid
        width="100%"
        gridCols="9fr 1fr"
        gridHeight="50px"
        gridGap={SPACING.spacing15}
        justifyContent="space-between"
        margin={`0 0 ${SPACING.spacing30} 0`}
      >
        <Grid
          width="100%"
          gridCols="200px 316px 150px 150px 50px"
          gridGap={SPACING.spacing15}
          alignItems="center"
          margin={`0 0 ${SPACING.spacing30} 0`}
        >
          <AutoCompleteInput
            control={control}
            errors={errors}
            label="Contrato"
            placeholder="Nº"
            disabled={!isAnaliseCre}
            valueName="cdContrato"
            optionValue="cdContrato"
            options={autoCompleteContract || []}
            loading={isLoadingContract}
            formValue="cdContrato"
            maxLength={100}
            type="dynamic"
            onChange={() => null}
            onChangeText={useDebounce(searchContract, 500)}
            marginTop={'auto'}
          />
          <Input
            control={control}
            errors={errors}
            label="Fornecedor"
            placeholder="Nome do Fornecedor"
            formValue="nmFornecedor"
            disabled
          />
          <Input
              control={control}
              errors={errors}
              label="CPF/CNPJ/CódSAP"
              placeholder="Nº"
              formValue="cdDocto"
              customMask={(cdDocto) => cdDocto && cdDocto.length > 9
                ? ['###.###.###-##', '##.###.###/####-##']
                : ['############']
              }
              disabled
            />
          <Picker
            label="Mês / Ano Verificação"
            inputFormat="MM/yyyy"
            id={'DatePickerId'}
            views={['month', 'year']}
            placeholder="mm/aaaa"
            control={control}
            disabled={!isAnaliseCre}
            formValue="NuAnoMesCompetencia"
            errors={errors}
            type="monthAndYear"
          />
          <MagnifyingGlassIcon onClick={handleGetCreInicial} />
        </Grid>
        {!checklist && !novaAnalise && idCre && (
          <Button
            text="Analisar"
            width="150px"
            onClick={() => StartAnalyze(false)}
            marginLeft={SPACING.spacing20}
          />
        )}
      </Grid>
      <Grid
        gridCols="1fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`0 0 ${SPACING.spacing30} 0`}
      >
        <TextArea
          control={control}
          errors={errors}
          formValue="txObjetoContrato"
          label="Objeto do Contrato"
          minRows={3}
          placeholder="Digite até 1000 caracteres"
          maxLength={1000}
          disabled
        />
      </Grid>
      <Grid
        gridCols="1fr 1fr 1fr 1fr 0.8fr 0.8fr 0.8fr 1.6fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`0 0 ${SPACING.spacing30} 0`}
      >
        <Picker
          label="Data Entrada"
          control={control}
          errors={errors}
          formValue="dtEntradaCRE"
          placeholder="dd/mm/aaaa"
          type="dayMonthYear"
          disabled
        />
        <Picker
          label="Data Retorno"
          control={control}
          errors={errors}
          formValue="dtRetornoCRE"
          placeholder="dd/mm/aaaa"
          type="dayMonthYear"
          disabled
        />
        <Picker
          label="Data Liberação"
          placeholder="dd/mm/aaaa"
          control={control}
          errors={errors}
          formValue="dtLiberacaoCRE"
          type="dayMonthYear"
          disabled
        />
        <Input
          control={control}
          errors={errors}
          label="Nº de Análise"
          placeholder="Nº"
          formValue="numAnalise"
          disabled
        />
        {renderBloqueado && (
          <CheckBox
            label="Bloqueado"
            checked={flBloqueado}
            onClick={null}
            disabled
          />
        )}
        {renderLiberado && (
          <CheckBox
            label="Liberado"
            checked={flLiberado}
            onClick={null}
            disabled
          />
        )}
        {renderFlagChecklist && (
          <CheckBox label="Checklist" checked={checklist} disabled />
        )}
        <Input
            errors={errors}
            label="Centro Planta"
            placeholder="Centro Planta"
            formValue="centroPlanta"
            value={nmCentroPlanta}
            disabled
        />
      </Grid>
    </>
  )
}

export default HeaderNovoCRE
